import React, { useState } from 'react';
import { TextField, Button } from '@cimpress/react-components';

import { logError } from 'src/loggingManager';

interface Props {
    existingDocRef?: string;
    onUpdateDocRef: (docRef: string) => void;
}

const DocRefSelector: React.FC<Props> = ({ existingDocRef, onUpdateDocRef }) => {
    const [existingDocRefState, setExistingDocRefState] = useState(existingDocRef);
    const [docRef, setDocRef] = useState(existingDocRef);
    const [fail, setFail] = useState(false);
    const [success, setSuccess] = useState(false);

    if (existingDocRef !== existingDocRefState) {
        setExistingDocRefState(existingDocRef);
        setDocRef(existingDocRef);
    }

    const onTypeText = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDocRef(e.target.value);
    };

    const updateDocRef = () => {
        setSuccess(false);
        setFail(false);

        fetch(docRef!)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                if (data.renderingInstructionsUrl) {
                    setSuccess(true);
                    onUpdateDocRef(data.renderingInstructionsUrl);
                } else {
                    throw new Error('The url is not a valid document reference!');
                }
            })
            .catch((e) => {
                setFail(true);
                logError(`failure to retrieve docRef (url=${docRef}): ${e}`);
            });
    };

    let style: 'success' | 'error' | undefined;
    if (success) {
        style = 'success';
    } else if (fail) {
        style = 'error';
    }
    return (
        <div className='choose-doc-ref'>
            <p className='choose-doc-ref__title'>Specify a document reference:</p>
            <div className='choose-doc-ref__wrapper'>
                <TextField
                    data-testid='editor-sceneInformation-docRef-input'
                    className={`choose-doc-ref__input ${style}`}
                    value={docRef}
                    onChange={onTypeText}
                    placeholder='Add Url Here'
                    status={style}
                    type='url'
                />

                <Button
                    data-testid='editor-sceneInformation-docRef-submit'
                    className='choose-sku__submit'
                    onClick={updateDocRef}>
                    Update
                </Button>
            </div>
        </div>
    );
};

export default React.memo(DocRefSelector);
